export const mainUrl = '/empresarios/cuenta-digital-pj';
export const subUrl = {
  validationCode: '/creacion-clave-internet/verificacion-otp',
  passwordCreation: '/creacion-clave-internet/nueva-clave',
  success: '/cuenta-creada',
  userInformation: '/creacion-clave-internet/datos-personales'
}
export const category = 'Cuenta digital PJ';
export const subcategory = {
  userInformation: 'Datos Personales - Creacion de Clave Internet - ',
  validationCode: 'Verificacion - Creacion de Clave Internet - ',
  passwordCreation: 'Ingresar Clave - Creacion de Clave Internet - ',
  success: 'Cuenta creada - '
}

export enum gtmType {
  PAGE_EVENT = 'PAGE_EVENT',
  INTERACTIVE_EVENT = 'INTERACTIVE_EVENT',
}
